import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { startCheckout } from "../utils/startCheckout.js";

const Footer = ({ isPaidSubscriber = false, verifiedEmail = null }) => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleBecomeMember = async (e) => {
    e.preventDefault();
    if (isPaidSubscriber) return;
    
    // If not logged in, redirect to login
    if (!verifiedEmail) {
      navigate("/login");
      return;
    }

    // If logged in, start checkout
    setIsLoading(true);
    try {
      await startCheckout(verifiedEmail);
    } catch (err) {
      console.error("Checkout error:", err);
      setIsLoading(false);
    }
  };

  return (
    <footer className="footer-box">
      <Link to="/about">About Us</Link> | <Link to="/faq">FAQ</Link> | <Link to="/guide">Guide</Link> | <Link to="/pricing">Pricing</Link> | <Link to="/disclaimer">Disclaimer</Link> |{" "}
      <Link to="/get-featured-on-podcast">Media</Link>{" "}
      {!isPaidSubscriber ? (
        <>
          {" "}|{" "}
          <button
            type="button"
            className="footer-link-button"
            onClick={handleBecomeMember}
            disabled={isLoading}
          >
            {isLoading ? "Loading…" : "Become member"}
          </button>
        </>
      ) : null}
      {" "}|{" "}
      <a
        href="https://x.com/wellwibuzz"
        target="_blank"
        rel="noopener noreferrer"
        className="footer-x-link"
        aria-label="Ahavibes on X"
      >
        X
      </a>{" "}
      |{" "}
      <a href="https://forms.gle/g5JzrEdbtMUqbMZL8">Your feedback matter to us!</a>
      <br />
      <span className="footer-powered-by-label">Powered by</span>{" "}
      <a href="https://labs.purplespot.ink/" target="_blank" rel="noopener noreferrer">
        PurpleSpot.Ink Labs
      </a>
    </footer>
  );
};

export default Footer;
